export default "__VITE_ASSET__BlLv7eTu__"